export default "__VITE_ASSET__9tuj3Iju__"